import { MuiMaterials } from "../../@index.js";
import SiteHeaderSiteSelect from "./SiteHeaderSiteSelect.js";
import SiteWindowTitle from "./SiteWindowTitle.js";
import { getWindowChromeThemeColor } from "./windowChromeTheme.js";

/** Compact Site XXXX tool switcher (text label, never a hamburger). */
export function SiteWindowToolNav({
    toolTitle,
    siteWindowId = null,
    siteGuid = null,
    textSecondary = null,
    titleId = undefined,
}) {
    return (
        <SiteWindowTitle
            title={toolTitle}
            siteWindowId={siteWindowId}
            siteGuid={siteGuid}
            textSecondary={textSecondary}
            titleId={titleId}
            compact
            size="small"
        />
    );
}

/**
 * Shared Site XXXX header leading controls:
 *   [Site select] | [Tool select] ……
 * Matches Cable Health: large site name, small tool name, vertical divider, no caret.
 *
 * Pass `includeTool={false}` when ChromeHeaderBar owns the tool slot so phones can wrap
 * the tool with action buttons instead of collapsing it to a hamburger.
 */
export default function SiteWindowHeaderLeading({
    toolTitle,
    siteWindowId = null,
    siteGuid = null,
    textSecondary = null,
    showSiteSelect = false,
    siteSelectValue = "",
    onSiteChange = null,
    sites = null,
    filterSite = null,
    siteSelectDisabled = false,
    includeAllSites = false,
    titleId = undefined,
    includeTool = true,
}) {
    // Prefer a solid accent over the faint panel border token (often ~30% opacity gold).
    const dividerColor =
        textSecondary
        || getWindowChromeThemeColor("#666666", "#c4a574");

    if (!showSiteSelect && !includeTool) {
        return null;
    }

    return (
        <MuiMaterials.Box
            sx={{
                display: "flex",
                alignItems: "center",
                minWidth: 0,
                maxWidth: "100%",
                flex: includeTool ? "1 1 auto" : "0 1 auto",
                overflow: "hidden",
            }}
        >
            {showSiteSelect ? (
                <>
                    <SiteHeaderSiteSelect
                        value={siteSelectValue || siteGuid || ""}
                        onChange={onSiteChange}
                        sites={sites}
                        filterSite={filterSite}
                        disabled={siteSelectDisabled}
                        textSecondary={textSecondary}
                        includeAllSites={includeAllSites}
                    />
                    {includeTool ? (
                        <MuiMaterials.Box
                            aria-hidden
                            sx={{
                                alignSelf: "center",
                                width: 1.5,
                                height: "1.4rem",
                                mx: 0.5,
                                flexShrink: 0,
                                borderRadius: 0.5,
                                backgroundColor: dividerColor,
                                opacity: 0.75,
                            }}
                        />
                    ) : null}
                </>
            ) : null}
            {includeTool ? (
                <SiteWindowToolNav
                    toolTitle={toolTitle}
                    siteWindowId={siteWindowId}
                    siteGuid={siteGuid}
                    textSecondary={textSecondary}
                    titleId={titleId}
                />
            ) : null}
        </MuiMaterials.Box>
    );
}
